module.exports = __webpack_public_path__ + "media/images/icons/outlined/bold-02cf857f9a7fc7afe867366c616d569a.svg";